import axios from "./axios-handler.service";
const BASE_URL = "/api/Erros";

export interface Lista {
  txtPesquisa: string;
  txtPeriodo: string;
  offset: number;
  limit: number;
  order?: string;
}

export interface Detalhe {
  descricao: string;
  detalhe: string;
  pagina: string;
  stackTrace: string;
}

export class ErrosService {
  static async Listar(lista: Lista): Promise<any> {
    const { txtPesquisa, txtPeriodo, offset, limit, order } = lista;
    const response = await axios.get<any>(`${BASE_URL}/Lista`, {
      params: {
        txtPesquisa,
        txtPeriodo,
        offset,
        limit,
        order
      },
    });
    return response.data;
  }

  static async Detalhes(idErro: number): Promise<Detalhe> {
    const response = await axios.get<Detalhe>(`${BASE_URL}/Detalhes`, {
      params: {
        idErro,
      },
    });
    return response.data;
  }

  static async Limpar(): Promise<void> {
    await axios.get<void>(`${BASE_URL}/Limpar`);
  }
}